import { createContext, useContext } from 'react';

export const IntelContext = createContext(null);

export function useIntel() {
  const ctx = useContext(IntelContext);
  return ctx;
}
